/**
 * Updates a form property and emits the updated form data
 * 
 * @param {string} propertyName - The name of the property to update
 * @param {*} value - The new value for the property
 */
export function updateFormProperty(propertyName, value) {
  this.$emit("update:formData", {
    ...this.formData,
    [propertyName]: value,
  });
}

/**
 * Creates an object of update methods for Vue form components
 * 
 * @param {Array<string>} properties - Array of property names to create update methods for
 * @returns {object} - Object of methods to be used in the component's methods option
 */
export function createFormMethods(properties) {
  const methods = {};

  properties.forEach(property => {
    const methodName = `update${property.charAt(0).toUpperCase() + property.slice(1)}`;
    methods[methodName] = function(value) {
      updateFormProperty.call(this, property, value);
    };
  });

  return methods;
}
